import { DashboardPage } from '@/modules/dashboard';

export default DashboardPage;
